import { bgBlur } from '@syntra/ui/theme/css';
import { useOffSetTop } from '@syntra/ui/hooks/use-off-set-top';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import { useAuthContext } from 'src/auth/hooks';

import Logo from 'src/components/logo';

import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';
import SettingsButton from './settings-button';
import WorkingPageSelector from './working-page-selector';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
  const theme = useTheme();
  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);
  const router = useRouter();
  const { logout, authenticated } = useAuthContext();

  const handleLogout = async () => {
    try {
      await logout({ logoutParams: { returnTo: window.location.origin } });
      router.replace('/');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo />

        <Stack direction="row" alignItems="center" spacing={1}>
          {authenticated && <WorkingPageSelector />}
          <SettingsButton />
          <Link
            color="inherit"
            sx={{ typography: 'subtitle2' }}
            component={RouterLink}
            href={paths.help}
            target="_blank"
            rel="noopener"
          >
            Need help?
          </Link>
          {authenticated && (
            <Button color="inherit" onClick={handleLogout} sx={{ typography: 'subtitle2' }}>
              Logout
            </Button>
          )}
        </Stack>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
